import { render } from "./HomeSections.vue?vue&type=template&id=d65b6fea&scoped=true"
const script = {}

import "./HomeSections.vue?vue&type=style&index=0&id=d65b6fea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d65b6fea"]])

export default __exports__